import React, {  } from 'react';

interface BurgerProps {
    fill?: string;
    secondaryFill?: string;
    width?: string;
    height?: string;
}

const Burger = (
    {
        fill = 'currentColor',
        secondaryFill = 'currentColor',
        width = '100%',
        height = '100%',
    }: BurgerProps
) => {
    return (
        <svg height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
            <g fill={secondaryFill}>
                <path d="M30,15H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,15,30,15z"/>
                <path d="M30,6H2C1.4,6,1,6.4,1,7s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,6,30,6z" fill={fill}/>
                <path d="M30,24H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,24,30,24z" fill={fill}/>
            </g>
        </svg>
    );
};

export default Burger;
